// extracted by mini-css-extract-plugin
export default {"button":"Button_button__1EObo","small":"Button_small__TfLFi"};